import { createContext } from "react";
export const SignalmizelyContext = createContext(null);
